import {
  Box,
  Input,
  Text,
  VStack,
  HStack,
  IconButton,
  Spinner,
  useToast,
} from '@chakra-ui/react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import { updateWhatsAppWebsite } from '../../../hooks/whatsapp_number';

export default function EditWebsitePage() {
  const navigate = useNavigate();
  const { orgId, whatsappNumberId } = useParams();
  const toast = useToast();

  const [website, setWebsite] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!orgId || !website.trim()) return;

    setSaving(true);
    const res = await updateWhatsAppWebsite(
      whatsappNumberId || '',
      orgId,
      website.trim(),
    );
    setSaving(false);

    if (res.success) {
      toast({ title: 'Website updated', status: 'success', duration: 1500 });
      navigate(-1);
    } else {
      toast({
        title: 'Update failed',
        description: 'Unable to update website',
        status: 'error',
        duration: 3000,
      });
    }
  };

  return (
    <Box bg="white" minH="100vh">
      {/* Header */}
      <HStack px={4} py={3} justify="space-between">
        <IconButton
          aria-label="Back"
          icon={<ArrowLeft />}
          variant="ghost"
          onClick={() => navigate(-1)}
        />

        <Text fontWeight="semibold">Website</Text>

        {saving ? (
          <Spinner size="sm" />
        ) : (
          <Text color="#25D366" cursor="pointer" onClick={handleSave}>
            Save
          </Text>
        )}
      </HStack>

      {/* Content */}
      <VStack px={4} mt={4} spacing={2} align="stretch">
        <Input
          value={website}
          onChange={(e) => setWebsite(e.target.value)}
          placeholder="https://yourwebsite.com"
          variant="flushed"
          autoFocus
        />
        <Text fontSize="xs" color="gray.500">
          This website will appear on your WhatsApp business profile.
        </Text>
      </VStack>
    </Box>
  );
}
